document.addEventListener('DOMContentLoaded', function () {
    function onElementAppeared(element) {
        element.addEventListener('click', function () {
            let details = document.querySelectorAll('details');
            details.forEach(details => {
                details.classList.remove('menu-opening');
                setTimeout(function () {
                    details.removeAttribute('open');
                }, 300);
            });
            document.body.classList.remove('mini-cart--open');
        });
    }
    const targetNode = document.body;
    const config = {childList: true, subtree: true};
    const callback = function (mutationsList, observer) {
        for (const mutation of mutationsList) {
            if (mutation.type === 'childList') {
                const element = document.querySelector('.close-cart-drawer');
                const conShop = document.querySelector('.mini-cart-button');
                const emptyConShop = document.querySelector('.empty-mini-cart-button-continue');
                if (element) {
                    onElementAppeared(element);
                }
                if (conShop) {
                    onElementAppeared(conShop);
                }
                if (emptyConShop) {
                    onElementAppeared(emptyConShop);
                }
            }
        }
    };
    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
});
document.addEventListener('DOMContentLoaded', function () {
    function toggleOverflowBasedOnDetails(detailsElement) {
        if (detailsElement.hasAttribute('open')) {
            document.documentElement.style.overflow = 'hidden';
        } else {
            document.documentElement.style.overflow = 'auto';
        }
    }
    const targetNode = document.querySelector('details.cart-drawer-container');
    if (targetNode) {
        toggleOverflowBasedOnDetails(targetNode);
        const config = { attributes: true, attributeFilter: ['open'] };
        const callback = function (mutationsList) {
            for (const mutation of mutationsList) {
                if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
                    toggleOverflowBasedOnDetails(mutation.target);
                }
            }
        };
        const observer = new MutationObserver(callback);
        observer.observe(targetNode, config);
    }
});